module.exports = __webpack_public_path__ + "img/远离热源.7086d731.jpg";